import React from 'react';
import { Link } from 'gatsby';
import { storyblokEditable, useStoryblokState } from 'gatsby-source-storyblok';
import { useLocation } from '@reach/router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core';
import { extractLanguage } from '../../helpers/common';

function Post({ post }) {
  const storyBlokPost = useStoryblokState(post);
  const location = useLocation();

  const language = extractLanguage(location.pathname);

  const { content } = storyBlokPost;
  const translatedSlug = storyBlokPost.translated_slugs?.length
    ? storyBlokPost.translated_slugs[0] : undefined;
  const title = translatedSlug && language === translatedSlug.lang
    ? translatedSlug.name : content?.title
  || storyBlokPost.name || storyBlokPost.slug;
  const featuredImg = content?.hero?.filename || '';
  return (
    <Link
      key={storyBlokPost.uuid}
      to={`/${storyBlokPost.full_slug}`}
      className="mx-auto aspect-[134/85] w-full relative group overflow-hidden"
    >
      <article
        itemScope
        itemType="http://schema.org/Article"
        className="bg-slate-100 dark:bg-latori-green-dark shadow-lg h-full"
      >
        {featuredImg
          && (
          <img
            src={`${featuredImg}/m/600x0`}
            alt={storyBlokPost.name || storyBlokPost.slug}
            className="w-full h-full object-cover absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]"
            loading="lazy"
          />
          )}
        <div className="bg-latori-green-dark opacity-90 w-full h-full absolute bottom-0 left-0 transition-[height] group-hover:h-[0%]" />
        <div className="w-full h-full absolute top-0 left-0 flex flex-col justify-center items-start px-4 group-hover:opacity-0 transition-opacity text-white">
          <h2 className="text-2xl" itemProp="headline">{title}</h2>
        </div>
      </article>
    </Link>
  );
}

function BlogGridView({ blok }) {
  let { posts } = blok;
  const location = useLocation();

  const currentLanguage = extractLanguage(location.pathname);
  if (Object.prototype.hasOwnProperty.call(posts[0], 'node')) {
    posts = posts.map(({ node }) => {
      if (node.content && typeof node.content === 'string') {
        return {
          ...node,
          content: JSON.parse(node?.content),
        };
      }
      return node;
    }).filter(({ lang }) => lang === currentLanguage);
  }

  return (
    <div {...storyblokEditable(blok)} className="px-4 lg:px-16 pb-8 lg:pb-32">
      <div className="mt-[60px] lg:mt-20 grid grid-cols-1 xl:grid-cols-3 md:grid-cols-2 gap-2 md:gap-4" id="blog-post-list">
        {posts.map((entry) => (
          <Post key={entry.uuid} post={entry} />
        ))}
        {blok?.show_more_tile && (
        <Link
          to={`${currentLanguage === 'default' ? '' : '/en'}/blog`}
          className="flex bg-green-800 hover:bg-green-900 text-white group w-full h-full py-12"
        >
          <div className="flex m-auto items-center group-hover:scale-105 transition-transform">
            <span className="mr-2">
              {currentLanguage === 'default' ? 'Mehr' : 'More'}
            </span>
            <FontAwesomeIcon
              icon={icon({ prefix: 'far', iconName: 'arrow-right' })}
              size="2x"
            />
          </div>
        </Link>
        )}
      </div>
    </div>
  );
}

export default BlogGridView;
